import React from 'react'
import { documentUrl } from '../../Elements/UI/fileLink'

function DocumentCard({item}) {
    const title = item?.Data?.Title || 'Document'
    const url = documentUrl(item)

    return (
        <div className="bl-doc">
            <div className="bl-doc__icon" aria-hidden="true">
                <ion-icon name="document-text-outline"></ion-icon>
            </div>
            <div className="bl-doc__body">
                <p className="bl-doc__title">{title}</p>
                {url ? (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary btn-sm"
                        aria-label={`View ${title} (opens in a new tab)`}
                    >
                        <ion-icon name="open-outline" aria-hidden="true"></ion-icon>
                        View
                    </a>
                ) : (
                    <button type="button" className="btn btn-secondary btn-sm" disabled>
                        File unavailable
                    </button>
                )}
            </div>
        </div>
    )
}

export default DocumentCard
